// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Target, ITarget } from "./Target.gen";

export interface ITargetResult {
	data: ITarget[] | undefined;

	hasMore: boolean;

	nextCursor: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class TargetResult {
	constructor(data?: ITargetResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new Target(d)) : [];
	}

	data: Target[] | undefined = [];

	hasMore: boolean = false;

	nextCursor: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.Pagination.TargetResult, ";
	$type?: string | undefined = TargetResult.$type;
}

